import { faChevronRight as farChevronRight } from "@awesome.me/kit-3777c2145e/icons/classic/regular";
import {
	faAward as fasAward,
	faBadgePercent as fasBadgePercent,
	faHandsHoldingDollar as fasHandsHoldingDollar,
	faHandshake as fasHandshake,
	faMagnifyingGlassChart as fasMagnifyingGlassChart,
	faMoneyBillTrendUp as fasMoneyBillTrendUp,
	faRocketLaunch as fasRocketLaunch,
	faUserHeadset as fasUserHeadset,
} from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import personCorporate from "@img/landing/landing-backgrounds/index-person-corporate.webp";
import personRetail from "@img/landing/landing-backgrounds/index-person-retail.webp";
import ladyImg from "@img/main-page-usp.jpg";
import { LandingAccordion } from "@landing/components/LandingAccordion";
import { InfoCard } from "@ui/components/InfoCard";
import { faBankmonitor } from "@ui/fortawesome/bankmonitor";
import { BmBadge, LandingContainer, List, addParameterToURL, getUrlParameter } from "bm-ui-kit";
import type { ReactNode } from "react";
import React from "react";
import { Accordion, Badge, Card, Col, Container, Row } from "react-bootstrap";
import { Ad } from "../Ad/Ad";
import {
	CALCULATOR_GRID_ITEMS_CORPORATE,
	CALCULATOR_GRID_ITEMS_RETAIL,
	type CalculatorGridTile,
} from "./ArticleCalculatorGrid.data";
import "./IndexTileGrid.scss";

interface Props {
	size?: "sm";
	variant: "retail" | "corporate";
	isEmbed?: boolean;
}

interface State {
	utm_medium?: string;
	utm_source?: string;
}

/**
 * @Shortcode
 *
 * @title "Kalkulátor lista"
 * @shortcode "index_tile_grid"
 * @type "widget"
 * @propsList "[{"size":"sm","variant":"retail"},{"variant":"retail"},{"variant":"corporate"},{"size":"sm"},{"size":"sm","isEmbed":true}]"
 */
export default class IndexTileGrid extends React.Component<Props, State> {
	public constructor(props: Props) {
		super(props);
		this.state = { utm_medium: undefined, utm_source: undefined };
	}

	public componentDidMount(): void {
		this.setState({
			utm_medium: getUrlParameter("utm_medium"),
			utm_source: getUrlParameter("utm_source"),
		});
	}

	public render(): ReactNode {
		const { size, variant, isEmbed } = this.props;
		const { utm_medium, utm_source } = this.state;

		const title =
			variant === "retail" ? (
				<>
					Egészségesen tartjuk
					<br />
					pénzügyeidet
				</>
			) : (
				<>
					Találd meg a megfelelő
					<br />
					hitelt és számlát
				</>
			);

		const colOptionalClass = size === "sm" ? "d-none" : "d-none d-lg-block";
		const gridItemsData = variant === "corporate" ? CALCULATOR_GRID_ITEMS_CORPORATE : CALCULATOR_GRID_ITEMS_RETAIL;

		return (
			<>
				<LandingContainer size="null" className="pt-3 py-sm-4" bgClassName="bg-index">
					<div className="mt-lg-5 mb-5 mb-lg-0 pb-5" style={{ maxWidth: "900px" }}>
						<span
							className={`display-2 font-weight-bold ${
								variant === "retail" ? "bg-title-primary text-white" : "bg-title-gold"
							}`}
						>
							{title}
						</span>
					</div>
					{this.renderBannerPerson()}
					<Row className="pt-2 px-2 align-items-stretch d-none d-lg-flex">
						{gridItemsData.map((originalItem) => {
							let item = { ...originalItem };

							//Marketing request was to replace biztositas grid item to vagyonkezeles
							if (item.name === "biztositas_tile") {
								item = {
									name: "hold-vagyonkezeles",
									clickAction: "to-hold-vagyonkezeles",
									title: "Vagyonkezelés",
									url: "/megtakaritasok/hold-vagyonkezeles/",
									icon: "/wp-content/themes/bankmonitor/img/menu/icon-set-stack.svg#vagyonkezeles",
									faIcon: fasMoneyBillTrendUp,
									new: false,
								};
							}

							return (
								<Col
									key={item.name}
									lg={size === "sm" || gridItemsData.length % 4 !== 0 ? 4 : 3}
									className={`my-2 px-md-2 ${
										item.optional ? colOptionalClass : ""
									} tile-menu-item-container`}
								>
									<div
										className={`${item.name === "lakashitel" ? "ribbon" : ""} bg-white py-4 px-2 h-100 border rounded shadow d-flex flex-column text-center position-relative justify-content-center align-items-center tile-menu-item`}
									>
										{item.new === true && (
											<Badge
												className="position-absolute m-1"
												variant="success"
												style={{ top: "0", right: "0" }}
											>
												Új
											</Badge>
										)}
										{item.faIcon ? (
											<FontAwesomeIcon
												className="mb-3 tile-menu-faicon display-3"
												icon={item.faIcon}
											/>
										) : (
											<img
												className="d-md-block d-none mb-2"
												loading="lazy"
												src={item.icon}
												alt={item.name}
												width="64"
												height="64"
											/>
										)}
										<a
											className="h4 mb-0 stretched-link d-none d-md-block"
											href={addParameterToURL(item.url, {
												link_type: "tile-menu-item",
											})}
											target={isEmbed ? "_blank" : undefined}
										>
											{item.title}
										</a>
										{!item.faIcon && (
											<img
												className="d-md-none mb-1"
												loading="lazy"
												src={item.icon}
												alt={item.name}
												width="48"
												height="48"
											/>
										)}
										<a
											className="h5 mb-0 text-uppercase stretched-link d-md-none"
											href={addParameterToURL(item.url, {
												link_type: "tile-menu-item",
											})}
											target={isEmbed ? "_blank" : undefined}
										>
											{item.title}
										</a>
										{item.name === "lakashitel" && (
											<span className="font-uppercase py-1">24h minősítés</span>
										)}
									</div>
								</Col>
							);
						})}
					</Row>
					<div className="mobile-dropdown-menu d-lg-none mb-3">
						<Accordion>{this.renderAccordionItems(gridItemsData)}</Accordion>
					</div>
				</LandingContainer>
				{this.renderInfoCard()}
				{this.renderAds()}
				<Container className="text-center mt-2 mb-5">
					<h3 className="mt-4 ">Több ezer ügyfélnek segítünk évente meghozni a legjobb pénzügyi döntést.</h3>
					<Row className="pt-2 px-2 justify-content-between d-lg-flex">
						<div className="d-md-flex flex-column mt-1 mt-md-0">
							<hr className="bg-primary mt-0 mb-1 index-hr d-none d-sm-block" />
							<span className="mr-2 font-weight-bold span-font">50+</span> bank és biztosító termékei
						</div>
						<hr className="bg-primary mt-0 mb-1 index-hr d-sm-none" />
						<div className="d-md-flex flex-column mt-1 mt-md-0 ">
							<hr className="bg-primary mt-0 mb-1 index-hr d-none d-sm-block" />
							<span className="mr-2 font-weight-bold span-font">20+</span> év szakmai tapasztalat
						</div>
						<hr className="bg-primary mt-0 mb-1 index-hr d-sm-none" />
						<div className="d-md-flex flex-column mt-1 mt-md-0">
							<hr className="bg-primary mt-0 mb-1 index-hr d-none d-sm-block" />
							<span className="mr-2 font-weight-bold span-font ">96%</span> ügyfél elégedettség
						</div>
						<hr className="bg-primary mt-0 mb-1 index-hr d-sm-none" />
						<div className="d-md-flex flex-column mt-1 mt-md-0">
							<hr className="bg-primary mt-0 mb-1 index-hr d-none d-sm-block" />
							<span className="mr-2 font-weight-bold span-font">30 000+</span> szerződés évente
						</div>
					</Row>
				</Container>
				<Container className="text-center bg-gray mb-2">
					<h3 className="m-2 pt-4">Miért válaszd Te is a Bankmonitort?</h3>
					<Row className="pt-2 px-2 align-items-center">
						<Col lg={3} className="p-2">
							<Card className="bg-white card-height">
								<FontAwesomeIcon className="text-primary pt-3 pb-1" size="2x" icon={fasAward} />
								<strong className="p-font font-weight-bold">Pénzügyi piactér</strong>
								<p className="text-center px-2 p-font">
									Ahol Te vagy a fontos, a bankok és a biztosítók versenyeznek érted.
								</p>
							</Card>
						</Col>
						<Col lg={3} className="p-2">
							<Card className="bg-white card-height">
								<FontAwesomeIcon className="text-primary pt-3 pb-1" size="2x" icon={fasBadgePercent} />
								<strong className="p-font font-weight-bold">Ingyenes</strong>
								<p className="text-center px-2 p-font">
									A pénzügyi tanácsadásunk komoly érték, de neked semmibe sem kerül.
								</p>
							</Card>
						</Col>
						<Col lg={3} className="p-2">
							<Card className="bg-white card-height">
								<FontAwesomeIcon
									className="text-primary pt-3 pb-1"
									size="2x"
									icon={fasMagnifyingGlassChart}
								/>
								<strong className="p-font font-weight-bold">Egyedi ajánlatok</strong>
								<p className="text-center px-2 p-font">
									Rajtunk keresztül a bankoktól kivételes árakat és kedvezményeket kaphatsz.
								</p>
							</Card>
						</Col>
						<Col lg={3} className="p-2">
							<Card className="bg-white card-height">
								<FontAwesomeIcon className="text-primary pt-3 pb-1" size="2x" icon={fasRocketLaunch} />
								<strong className="p-font font-weight-bold">Függetlenek vagyunk</strong>
								<p className="text-center px-2 p-font">
									Ezért tudunk objektív és átlátható pénzügyi útmutatást nyújtani miden döntésedhez.
								</p>
							</Card>
						</Col>
						<Col lg={3} className="p-2">
							<Card className="bg-white card-height">
								<FontAwesomeIcon className="text-primary pt-3 pb-1" size="2x" icon={fasUserHeadset} />
								<strong className="p-font font-weight-bold">Online</strong>
								<p className="text-center px-2 p-font">
									Gyors, egyszerű és kényelmes. Nem utazol, nem parkolsz és nem állsz sorban nálunk.
								</p>
							</Card>
						</Col>
						<Col lg={3} className="p-2">
							<Card className="bg-white card-height">
								<FontAwesomeIcon
									className="text-primary pt-3 pb-1"
									size="2x"
									icon={fasHandsHoldingDollar}
								/>
								<strong className="p-font font-weight-bold">Teljes körű pénzügyek</strong>
								<p className="text-center px-2 p-font">
									Mindenre van megoldásunk, legyen az biztosítás, hitel vagy befektetés.
								</p>
							</Card>
						</Col>
						<Col lg={3} className="p-2">
							<Card className="bg-white card-height">
								<FontAwesomeIcon className="text-primary pt-3 pb-1" size="2x" icon={fasHandshake} />
								<strong className="p-font font-weight-bold">Végig kísérünk</strong>
								<p className="text-center px-2 p-font">
									Az első kattintástól a szerződésig melletted állunk, nem maradsz magadra a
									kérdéseiddel.
								</p>
							</Card>
						</Col>
						<Col lg={3} className="p-2 d-none d-lg-block">
							<img src={ladyImg} className="rounded card-img object-fit-scale-down" alt="" />
						</Col>
					</Row>
				</Container>
			</>
		);
	}

	private renderAccordionItems(gridItemsData: CalculatorGridTile[]): JSX.Element[] {
		const extendedGridItemData = [
			...gridItemsData,
			{
				name: "hold-vagyonkezeles",
				clickAction: "to-hold-vagyonkezeles",
				title: "Vagyonkezelés",
				url: "/megtakaritasok/hold-vagyonkezeles/",
				icon: "/wp-content/themes/bankmonitor/img/menu/icon-set-stack.svg#vagyonkezeles",
				faIcon: fasMoneyBillTrendUp,
				new: false,
			},
		];

		return extendedGridItemData.map((item) => {
			if (item.subMenuOptions?.length > 0) {
				return (
					<LandingAccordion
						id={item.title as string}
						title={item.title as string}
						key={item.name}
						icon={<FontAwesomeIcon icon={item.faIcon} fixedWidth />}
						className="grid-accordion"
						merged
						titlePostFix={
							item.title === "Lakáshitel" ? (
								<BmBadge
									className="ml-2 ml-md-4"
									size="sm"
									prepend={<FontAwesomeIcon icon={faBankmonitor} />}
								>
									<strong>24h minősítés</strong>
								</BmBadge>
							) : undefined
						}
					>
						{item.subMenuOptions.map((subMenuOption) => (
							<div key={subMenuOption.title} className="merged sub-menu-item">
								<a
									href={addParameterToURL(subMenuOption.url, {
										link_type: "mobile-accordion-sub-menu-item",
									})}
									className="accordion-header text-reset d-flex justify-content-between pl-5"
								>
									{subMenuOption.title}
									<FontAwesomeIcon icon={farChevronRight} />
								</a>
							</div>
						))}
					</LandingAccordion>
				);
			}

			return (
				<div className="grid-accordion accordion-item merged" key={item.name}>
					<a
						href={addParameterToURL(item.url, {
							link_type: "mobile-accordion-menu-item",
						})}
						className="accordion-header text-reset d-flex justify-content-between"
					>
						<span className="accordion-icon">
							<FontAwesomeIcon icon={item.faIcon} className="mr-2" fixedWidth />
						</span>
						<h3 className="d-inline-block">{item.title}</h3>
						<FontAwesomeIcon icon={farChevronRight} />
					</a>
				</div>
			);
		});
	}

	private renderInfoCard(): ReactNode {
		const { variant } = this.props;

		if (variant === "corporate") {
			return (
				<Container>
					<InfoCard
						title="Előbírálat 24 órán belül!"
						className="mt-4 mt-lg-0 mb-4 text-white"
						variant="corporate"
					>
						<Card.Body>
							<List itemStyle="tick">
								<List.Item>
									<strong>Több banktól</strong> is kérünk Neked ajánlatot!
								</List.Item>
								<List.Item>
									<strong>Hitelbírálat akár 4 munkanapon belül</strong> (hitelbírálathoz szükséges
									teljes dokumentáció megléte esetén)
								</List.Item>
								<List.Item>
									<strong>Kényelmesebb és gyorsabb</strong>, mintha besétálnál a bankba
								</List.Item>
								<List.Item>
									<strong>Bankfiókban nem elérhető ajánlatok számlavezetésre</strong>
								</List.Item>
							</List>
						</Card.Body>
					</InfoCard>
				</Container>
			);
		}

		return (
			<Container>
				<InfoCard
					title="Online lakáshitel a Bankmonitornál!"
					className="mt-4 mt-lg-0 mb-4"
					variant="bg-retail-new"
				>
					<Card.Body className="d-flex justify-content-between align-items-center flex-column-reverse flex-lg-row">
						<div className="flex-fill mr-md-4">
							<List itemStyle="tick">
								<List.Item>
									<strong>Előbírálat 24 órán belül</strong>, elsőként az országban!
								</List.Item>
								<List.Item>
									Átlagosan <strong>0,7%-kal kedvezőbb kamatot kapsz</strong>, mintha besétálnál a
									bankba
								</List.Item>
								<List.Item>
									Kötelező érvényű ajánlatot is kaphatsz online, az abban szereplő kamatot{" "}
									<strong>4 hónapig garantálja a bank</strong>
								</List.Item>
								<List.Item>
									Bankmonitor árgarancia: <strong>nem kapsz jobb ajánlatot sehol</strong>
								</List.Item>
								<List.Item>
									<strong>Több banktól</strong> kapsz előminősítést egy körben, gyorsan, kényelmesen
								</List.Item>
							</List>
						</div>
					</Card.Body>
				</InfoCard>
			</Container>
		);
	}

	private renderAds(): ReactNode {
		return (
			<Container>
				<Ad
					name="970x250 TOP1"
					code="5967603"
					width="970"
					height="250"
					type="desktop"
					gapeless
					priority={100}
				/>
				<Ad
					name="300x250 MOBIL TOP1"
					code="5967598"
					width="300"
					height="250"
					type="non-desktop"
					gapeless
					priority={98}
				/>
			</Container>
		);
	}

	private renderBannerPerson(): ReactNode {
		const { variant } = this.props;

		return (
			<div className="text-center">
				<div
					className={`index-banner-circle rounded-circle bg-${
						variant === "corporate" ? "corporate" : "retail"
					}-gradient`}
				/>
				<img
					src={variant === "corporate" ? personCorporate : personRetail}
					alt="Bankmonitor"
					className={`index-banner-person index-banner-person-${variant}`}
				/>
				<div className="index-banner-bottom-strip bg-white d-none d-lg-block" />
			</div>
		);
	}
}
